import { useState, useCallback } from "react";

type ModalKey = "flightDetails" | "calculationDebug" | "ancillaries" | "priceDetails" | "rules";

export const useFareModals = () => {
    const [modals, setModals] = useState<Record<ModalKey, boolean>>({
        flightDetails: false,
        calculationDebug: false,
        ancillaries: false,
        priceDetails: false,
        rules: false,
    });

    const toggleModal = useCallback((key: ModalKey) => {
        setModals((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    }, []);

    const closeAllModals = () => {
        setModals({
            flightDetails: false,
            calculationDebug: false,
            ancillaries: false,
            priceDetails: false,
            rules: false,
        });
    };

    return { modals, toggleModal, closeAllModals };
};
